import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FiltersComponent } from './filters.component';
import { ColorPickerModule } from 'ngx-color-picker';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { MenucolorsComponent } from './filter-menucolors/menucolors.component';
import { FilterfilesComponent } from './filter-files/filterfiles.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { FilterGenerationModule } from './filter-generation/filter-generation.module';

@NgModule({
  declarations: [FiltersComponent, MenucolorsComponent, FilterfilesComponent],
  imports: [
    CommonModule,
    FormsModule,
    ColorPickerModule,
    TooltipModule,
    FilterGenerationModule,
    NgMultiSelectDropDownModule.forRoot(),
  ],
  exports: [FiltersComponent],
})
export class FiltersModule {}
